import type { IconProps } from './types';
import './icons.css';

export default function Download({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-download ${className || ''}`}
    >
      <path
        d="M14 11.333v1.334c0 1.066-.333 2-1.6 2H3.6c-1.267 0-1.6-.934-1.6-2v-1.334M8 11.6V1.2m0 10.4L3.6 7.318M8 11.6l4.4-4.282"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        fill="transparent"
      />
    </svg>
  );
}
